import { render, staticRenderFns } from "./userHeadUpload.vue?vue&type=template&id=040e78b7&scoped=true&"
import script from "./userHeadUpload.vue?vue&type=script&lang=js&"
export * from "./userHeadUpload.vue?vue&type=script&lang=js&"
import style0 from "./userHeadUpload.vue?vue&type=style&index=0&id=040e78b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e78b7",
  null
  
)

export default component.exports